import { useParams } from "react-router-dom";
import { ProductGallery } from "../components/ProductGallery";
// import { useLouveApi } from '../hooks';

// TODO - get vendor details from api
const VendorProductsPage = () => {
  const { vendorId } = useParams();
  const url = `Product/ProductsByVendor/${vendorId}`;

  return (
    <section className="flex flex-col px-8 md:px-16 py-5 md:py-10 gap-10 w-full mt-48">
      <div
        style={{ background: "#FAFAFA" }}
        className="flex items-center justify-between flex-col md:flex-row p-6 w-full"
      >
        <div className="flex items-center gap-4">
          <div class="avatar">
            <div class="rounded-btn w-24 h-24">
              <img
                src="http://daisyui.com/tailwind-css-component-profile-1@56w.png"
                alt=""
              />
            </div>
          </div>
          <div className="gap-3">
            <h1 className="font-bold text-3xl mb-4">Amaka Fabriks</h1>
            <span className="bg-green border border-green rounded-full px-8 py-1 bg-opacity-20 text-green text-sm">
              Vendor
            </span>
          </div>
        </div>
        <div>
          <img src="/assets/vendorShop.svg" alt="" />
        </div>
      </div>
      <h2 className="font-semibold capitalize">Sold by this vendor</h2>
      <ProductGallery url={url} />
    </section>
  );
};

export default VendorProductsPage;
